import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  margin: 16px 0;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #0F0F0F;
  margin-bottom: 8px;
`;

export const RefundContent = styled.div`
  display: flex;
  width: 100%;
  border-left: 4px solid #9B5AF8;
  padding-left: 16px;
`;

export const RefundInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RefundAmount = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #123051;
`;

export const RefundDescription = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #565556;
`;

export const RefundNote = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  font-style: italic;
  line-height: 18px;
  color: #565556;
  margin-top: 8px;
`; 